// Decodes over-escaped HTML coming from the question bank.
//
// Some question / option HTML is stored HTML-escaped (e.g. "&lt;p&gt;" instead
// of "<p>", sometimes doubly so). When such a string is injected with
// dangerouslySetInnerHTML — which is what <MathJax.Html> does — the browser only
// unescapes one entity level, so the tags render as literal text instead of
// markup. A <textarea> decodes one entity level at a time; we repeat until the
// real tags are no longer outnumbered by the escaped ones (capped at a few
// passes so pathological input can't loop). Content that is already valid HTML
// short-circuits on the first check and is returned untouched.

// A real tag ("<p>", "</p>", "<img …>") vs. an escaped tag ("&lt;p&gt;", …).
// Both require a letter (optionally after "/") immediately after the bracket, so
// an escaped inequality such as "a &lt; b" is NOT treated as a tag. The escaped
// pattern also allows extra "&amp;" nesting ("&amp;lt;p&amp;gt;") so doubly
// escaped tags are still recognised and get unwrapped over successive passes.
const REAL_TAG = /<\/?[a-z][\s\S]*?>/gi;
const ESCAPED_TAG = /&(?:amp;)*lt;\/?[a-z][\s\S]*?&(?:amp;)*gt;/gi;

const countMatches = (str, regex) => (str.match(regex) || []).length;

export const decodeEscapedHtml = (value) => {
	let html = value == null ? "" : String(value);
	if (typeof document === "undefined") return html;
	for (let pass = 0; pass < 3; pass += 1) {
		if (countMatches(html, ESCAPED_TAG) <= countMatches(html, REAL_TAG)) break;
		const decoder = document.createElement("textarea");
		decoder.innerHTML = html;
		const decoded = decoder.value;
		if (!decoded || decoded === html) break;
		html = decoded;
	}
	return html;
};
